import { Link } from 'react-router';
import { FileQuestion } from 'lucide-react';
import { Button } from '@/components/ui/button';

const NotFoundPage = () => (
  <div className="mx-auto flex max-w-md flex-col items-center gap-4 py-24 text-center">
    <span className="flex size-12 items-center justify-center rounded-full border border-border bg-secondary">
      <FileQuestion className="size-5 text-muted-foreground" aria-hidden />
    </span>
    <div>
      <h1 className="text-xl font-semibold tracking-tight">This page does not exist</h1>
      <p className="mt-2 text-sm text-muted-foreground">The address may be mistyped, or the page may have moved.</p>
    </div>
    <Button asChild variant="outline">
      <Link to="/">Back to overview</Link>
    </Button>
  </div>
);

export default NotFoundPage;
